import { h, Component } from 'preact';
import style from './style.scss';
import {connect} from 'preact-redux';
import {TicketModel} from '/chat/src/redux/model';
import Customization from '/chat/src/redux/model/customization/model';
import SVG from 'react-inlinesvg'



class StarRating extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: -1, //Default to -1 until the backend api returns the rating
            hoveredValue: -1,
            rating: -1,
        };
    }

    componentDidMount() {
        this.props.updateRatingHandle = TicketModel.updateRating(this.props.room);
        this.props.getRatingHandle = () => TicketModel.getRating(this.props.room);
        this.props.getRatingHandle()
          .then(rating => {
              this.setState({ selectedValue: rating });
          })
          .catch(error => {
            console.error("Error in fetching rating", error); // This will log any error that occurred during the fetch
          });
    }

    handleMouseOver = (value) => {
        this.setState({ hoveredValue: value });
    }

    handleClick = (value) => {
        // Set the rating using the backend api
        this.props.updateRatingHandle(value)
        // TODO: Fix so that the rating is only set if the backend api returns a success
            // .then(success => {
            //   console.log("Is it ok", success.ok);
            //   if (success.ok) {
            //     this.setState({ selectedValue: value });
            //   }
            // })
            // .catch(error => {
            //   console.error("Error in updating rating", error);
            // });
        this.setState({ selectedValue: value });

    }

    handleMouseLeave = () => {
        this.setState({ hoveredValue: -1 });
    }

    constructStars = () => {
        const { selectedValue, hoveredValue } = this.state;
        const stars = [];

        for (let i = 1; i <= 5; i++) {
            const isFilled = hoveredValue <= selectedValue ? i <= selectedValue : i <= hoveredValue;
            stars.push(
                <svg
                    id="a"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="-10 -10 60 60"
                    width="40" height="40"
                    data-value={i}
                    alt="star"
                    onMouseOver={() => this.handleMouseOver(i)}
                    onClick={() => this.handleClick(i)}
                    onMouseLeave={() => this.handleMouseLeave()}>
                    <path class={style.star} stroke-linecap="round" stroke={this.props.color} fill={isFilled ? this.props.color : "none"} stroke-linejoin="round" stroke-width="3px" d="M37.94,17.79c.39-.34,.29-.67-.23-.72l-10.71-1.02c-.52-.05-1.11-.48-1.32-.96l-4.28-9.87c-.21-.48-.55-.48-.75,0l-4.28,9.87c-.21,.48-.8,.91-1.32,.96l-10.71,1.02c-.52,.05-.62,.37-.23,.72l8.07,7.12c.39,.34,.62,1.04,.5,1.55l-2.34,10.5c-.11,.51,.16,.71,.61,.44l9.27-5.47c.45-.26,1.18-.26,1.63,0l9.27,5.47c.45,.26,.72,.07,.61-.44l-2.34-10.5c-.11-.51,.11-1.21,.5-1.55l8.07-7.12Z"/>
                    data-value={i}
                </svg>

            );
        }
        return stars;
    }

    render() {
        const { selectedValue, hoveredValue } = this.state;
        this.stars = this.constructStars();


        return (
            <div className={style.ratingContainer}>
                <div>
                    <p className={style.ratingTitle}>{selectedValue >0 ? this.props.language.get("ThankForFeedback") : this.props.language.get("RatingPrompt")}</p>
                </div>
                <div className={style.rating}>
                    {this.stars}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const language = Customization.getLanguage(state)
    const color = Customization.getColor(state);
    const room = TicketModel.getCurrentRoom(state)
    return {
        room, language, color
    };
}

export default connect(mapStateToProps)(StarRating);



// WEBPACK FOOTER //
// ./routes/Chat/Rating/index.js